import { render, staticRenderFns } from "./ModalXml.vue?vue&type=template&id=e2fbf144&"
import script from "./ModalXml.vue?vue&type=script&lang=js&"
export * from "./ModalXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports